/** Centralized admin route paths — single source of truth for all `/admin/*` navigation. */
export const ADMIN_ROUTES = {
  overview: "/admin/overview",
  employees: "/admin/employees",
  employeesAdd: "/admin/employees/add",
  employeeDetail: (id: number | string) => `/admin/employees/${id}` as const,
  employeeEdit: (id: number | string) => `/admin/employees/${id}/edit` as const,
  systems: "/admin/systems",
  addSystem: "/admin/systems/add",
  systemDetail: (id: string) => `/admin/systems/${id}` as const,
  organizationSystemDetail: (organizationSystemId: number | string) =>
    `/admin/systems/org-${organizationSystemId}` as const,
  devices: "/admin/devices",
  devicesAdd: "/admin/devices/add",
  deviceDetail: (deviceInventoryId: string) =>
    `/admin/devices/${deviceInventoryId}` as const,
  deviceEdit: (deviceInventoryId: string) =>
    `/admin/devices/${deviceInventoryId}/edit` as const,
  insuranceRequirements: "/admin/insurance-requirements",
  /** Matches any admin route — use with `path.startsWith()` */
  prefix: "/admin/",
} as const;
